import React from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import _ from "lodash";
import { AVAIL_SCOPES } from "env.config";
import { store } from "services/state";
import { validateAppDetail } from "utils/function-utils";

const AddAppDetail = ({
  email,
  appFormData,
  setAppFormData,
  openAddModal,
  setOpenAddAppModal,
  onSaveUpdateApp,
  ENVIDE,
}) => {
  const handleChangeAppName = (_e, { value }) =>
    setAppFormData({
      ...appFormData,
      appName: value,
      appNameValid: true,
      appNameErrorMessage: "",
    });
  const handleChangeScope = (_e, { checked, value }) => {
    setAppFormData({
      ...appFormData,
      oauthScope: checked
        ? appFormData.oauthScope.concat(value)
        : appFormData.oauthScope.filter((item) => item !== value),
      oauthScopeValid: true,
    });
  };
  const handleCancelUpdate = () => {
    setOpenAddAppModal(false);
    setAppFormData({
      appName: "",
      oauthScope: [],
      appNameValid: true,
      appNameErrorMessage: "",
      oauthScopeValid: true,
    });
  };
  const handleSaveUpdate = () => {
    const newAppFormData = validateAppDetail(appFormData);
    if (newAppFormData) {
      setAppFormData(newAppFormData);
      return;
    }
    setOpenAddAppModal(false);
    const addUsagePlanId = getUsagePlanIdParams();
    const userName = email.current;
    const { appName, oauthScope } = appFormData;
    const params = {
      operation: "addApp",
      appName,
      oauthScope,
      userName,
      addUsagePlanId,
    };
    onSaveUpdateApp(params);
  };

  const getUsagePlanIdParams = () => {
    // only apiGateway api need to subscribe
    const apiList = store.apiList.apiGateway;
    const acceptableEnvideList = new Set();
    // app assigned scopes
    const scopeList = appFormData.oauthScope.map((scope) =>
      scope.replace(/^42QAPI\//, "")
    );
    // scopes map to envide
    for (let key in ENVIDE) {
      if (scopeList.includes(ENVIDE[key].scope)) {
        acceptableEnvideList.add(key);
      }
    }
    // envide map to related apis
    const acceptableApiList = apiList.filter((api) => {
      let apiEnv = "";
      const swaggerApiName = api.swaggerApiName;
      if (new RegExp(`^MES16-.*`).test(swaggerApiName)) {
        apiEnv = swaggerApiName.split("-")[1];
      } else {
        apiEnv = swaggerApiName.split("-")[0];
      }
      return acceptableEnvideList.has(apiEnv);
    });
    // api map to usagePlanId
    const usagePlanIdList = Object.keys(
      _.groupBy(acceptableApiList, (api) => {
        return api.usagePlan.id;
      })
    );
    return usagePlanIdList;
  };

  const getAppNameError = () => {
    const { appNameValid, appNameErrorMessage } = appFormData;
    if (appNameValid) {
      return false;
    } else {
      if (appNameErrorMessage) {
        return appNameErrorMessage;
      } else {
        return true;
      }
    }
  };

  return (
    <Modal
      closeIcon
      size="small"
      open={openAddModal}
      onClose={handleCancelUpdate}
    >
      <Modal.Header>Add App</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>App Name</label>
            <Form.Input
              error={getAppNameError()}
              defaultValue={appFormData.AppName}
              placeholder="App Name"
              onChange={handleChangeAppName}
            />
          </Form.Field>
          <Form.Field required>
            <label>Allowed Scopes</label>
            {AVAIL_SCOPES.map((item) => {
              return (
                <Form.Field key={item}>
                  <Form.Checkbox
                    error={!appFormData.oauthScopeValid}
                    label={item}
                    value={item}
                    defaultChecked={
                      appFormData.oauthScope &&
                      appFormData.oauthScope.includes(item)
                    }
                    onChange={handleChangeScope}
                  />
                </Form.Field>
              );
            })}
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancelUpdate}>Cancel</Button>
        <Button type="submit" positive onClick={handleSaveUpdate}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export { AddAppDetail };
